import { render, staticRenderFns } from "./appraisalCategory.vue?vue&type=template&id=0d31040e&"
import script from "./appraisalCategory.vue?vue&type=script&lang=js&"
export * from "./appraisalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d31040e')) {
      api.createRecord('0d31040e', component.options)
    } else {
      api.reload('0d31040e', component.options)
    }
    module.hot.accept("./appraisalCategory.vue?vue&type=template&id=0d31040e&", function () {
      api.rerender('0d31040e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/appraisalCategory.vue"
export default component.exports